// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__12E0Y","footer":"ReportModalFilter_footer__39qwO"};